<section class="hero" appReveal>
  <h1>{{ 'hero.titulo' | translate }}</h1>
  <p class="subtitulo">{{ 'hero.subtitulo' | translate }}</p>
</section>
